import { API_CONST } from '../middlewares/api'

import { handleActions, createAction } from 'redux-actions'

const initial = {
  state: 'login',
  loginId: null,
  userId: null,
  error: null,
  _id: null,
  __data: {}
}

const generateActions = prefix => ([ `${prefix}/START`, `${prefix}/SUCCESS`, `${prefix}/FAILURE` ])

const authActions = generateActions('claim/auth')

const requestCodeActions = generateActions('claim/requestCode')
const confirmCodeActions = generateActions('claim/confirmCode')

export const logIn = createAction(API_CONST, (login, userId) => ({
  method: 'post',
  url: 'auth/app',
  params: { login, userId },
  actions: authActions
}))

// export const requestCode = createAction(API_CONST, userLoginId => ({
//   actions: requestCodeActions,
//   url: `auth/app/auth/${userLoginId}`
// }))

export const confirmCode = createAction(API_CONST, (userLoginId, codeValue) => ({
  method: 'post',
  params: { codeValue, platform: 'site'},
  actions: confirmCodeActions,
  url: `auth/app/auth/${userLoginId}`
}))

export const requestCode = createAction(API_CONST, (phone) => {
  return {
    method: 'post',
    params: { phone: phone },
    actions: requestCodeActions,
    url: `auth/code`
  }
})

export const setState = createAction('claim/SET_STATE', state => ({ state }))
export const clearAuthData = createAction('auth/CLEAR_AUTH_DATA', () => null)
export const clearError = createAction('auth/CLEAR_AUTH_ERROR')

// ------------ //

export default handleActions({
  [clearError]: state => ({ ...state, error: null }),
  [clearAuthData]: state => ({ ...state, state: 'login', loginId: null, userId: null }),
  // [authActions[0]]: state => ({ ...state, error: null }),
  // [authActions[1]]: (state, { payload }) => ({ ...state, _id: payload.message.response.data }),
  // [authActions[2]]: (state, { payload }) => ({ ...state, error: payload.message.response.data.error }),
  //
  [requestCodeActions[0]]: state => ({ ...state, error: null }),
  //[requestCodeActions[1]]: state => ({ ...state,  state: 'confirm'}),
  [requestCodeActions[1]]: (state, { payload }) => { return { ...state, _id: payload._id  }},
  //
  [confirmCodeActions[0]]: state => ({ ...state, error: null }),
  [confirmCodeActions[1]]: state => ({ ...state, state: 'logged'}),

  [setState]: (state, { payload }) => ({ ...state, state: payload.state }),

}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/claim.js